import { Box, Typography } from '@mui/material';
import { IconContext } from 'react-icons';
import { BsCheckCircle } from 'react-icons/bs';
import { Link } from 'react-router-dom';
import { StyledTextButton } from '../../styles';
import { CUSTOM_THEME_COLORS, REGISTER_SUCCESS_TEXT } from '../../variables';

const RegisterSuccess = () => {
  return (
    <Box
      sx={{
        width: { xs: '80vw', sm: '30vw' },
        marginTop: { xs: 2, sm: 5 },
        marginBottom: { xs: 2, sm: 5 },
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        gap: 2,
      }}
    >
      <IconContext.Provider
        value={{ style: { color: CUSTOM_THEME_COLORS.lightGreen, margin: 1 } }}
      >
        <BsCheckCircle size={50} />
      </IconContext.Provider>

      <Typography marginBottom={2}>{REGISTER_SUCCESS_TEXT}</Typography>

      <StyledTextButton
        variant='contained'
        component={Link}
        to='/'
        title='Ir para a homepage'
      >
        Ir para a homepage
      </StyledTextButton>
    </Box>
  );
};

export default RegisterSuccess;
